module.exports = __webpack_public_path__ + "img/1320.969abf09.gif";